import lodash, { isEmpty } from 'lodash'
import React, { ReactElement, useContext, useEffect, useMemo } from 'react'

import { Col, FormRow } from '../../../../../1stlog-ui/src/components/Bootstrap'
import Card from '../../../../../1stlog-ui/src/components/Card'
import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  Label,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../1stlog-ui/src/components/Field/useFieldState'
import { useFieldArray } from '../../../../../1stlog-ui/src/components/FieldArray'
import { LanguageContext } from '../../../../../1stlog-ui/src/components/LanguageSelect'
import { LanguageSelectComponent } from '../../../../../1stlog-ui/src/components/LanguageSelect/LanguageSelectComponent'
import { getIsGO } from '../../../../../1stlog-ui/src/utils/getIsGO'
import ClientNotificationsHandler from './ClientNotificationsHandler'
import Contact from './Contact'
import Notification from './Notification'

const ClientNotifications = (): ReactElement => {
  const { fields } = useFieldArray('clientNotifications')

  const clientNotifications = useField('clientNotifications')

  const clientNotificationsDisabled = useField('clientNotificationsDisabled')

  const isPickup = useField('isPickup')

  const [clientNotificationsLanguage, setClientNotificationsLanguage] =
    useFieldState<string | undefined>('clientNotificationsLanguage')

  const { value: defaultLanguage } = useContext(LanguageContext)

  useEffect(() => {
    if (isEmpty(clientNotificationsLanguage)) {
      setClientNotificationsLanguage(i18n.language || defaultLanguage)
    }
  }, [clientNotificationsLanguage])

  const addressField = useMemo(
    () => `${isPickup ? 'pickup' : 'delivery'}.address`,
    [isPickup],
  )

  return (
    <>
      <ClientNotificationsHandler />
      {!lodash.isEmpty(clientNotifications) && (
        <Card
          title={i18n.t('client_notifications', 'Kundenbenachrichtigungen')}
        >
          <Field name="clientNotificationsDisabled">
            <Checkbox>
              {i18n.t(
                'no_client_notifications',
                'Keine Kundenbenachrichtigungen gewünscht',
              )}
            </Checkbox>
          </Field>
          {!clientNotificationsDisabled && (
            <>
              <div hidden={!getIsGO()}>
                <div>
                  <Label>
                    {i18n.t(
                      'language_of_notifications',
                      'Sprache der Benachrichtigungen',
                    )}
                  </Label>
                </div>
                <div>
                  <LanguageSelectComponent
                    useMinWidth={false}
                    value={clientNotificationsLanguage}
                    onChange={({ value }) =>
                      setClientNotificationsLanguage(value)
                    }
                  />
                </div>
              </div>
              <div className="mt-1">
                <Contact addressField={addressField} isPickup={isPickup} />
                <div className="mt-1">
                  {fields.map((field, index) => (
                    <FormRow key={field}>
                      <Col>
                        <Notification name={field} />
                      </Col>
                    </FormRow>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card>
      )}
    </>
  )
}

export default ClientNotifications
